import * as moment from 'moment';



export const getDHMS = (seconds: any) => {
  if (seconds) {
    const dhms: any = {}
    dhms.Days = moment.duration(
      seconds,
      'seconds'
    ).days();
    dhms.Hours = moment.duration(
      seconds,
      'seconds'
    ).hours();
    dhms.Minutes = moment.duration(
      seconds,
      'seconds'
    ).minutes();
    dhms.Seconds = moment.duration(
      seconds,
      'seconds'
    ).seconds();
    return dhms
  }
  return 0
}

export const getSeconds = (dhms: any) => moment.duration({
  seconds: dhms.Seconds,
  minutes: dhms.Minutes,
  hours: dhms.Hours,
  days: dhms.Days
}).asSeconds()

export const minutesToDayHourMin = (totalMinutes: number): any => {
  const totalHours = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  const d = Math.floor(totalHours / 24);
  const h = totalHours % 24;

  if (d > 0) return `${d}d ${h}h ${m}m`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
};